import { I18n } from '@core/i18n';

const DEFAULT_LANGUAGE = I18n.EN;
const STORAGE_KEY = 'lang';

const SUPPORTED_LANGUAGES: { label: string; value: I18n }[] = [
    { label: 'English', value: I18n.EN },
    { label: 'Romanian', value: I18n.RO },
];

function initialize(): I18n {
    const savedLang = localStorage.getItem(STORAGE_KEY) || '';
    return isValidLanguage(savedLang) ? savedLang : DEFAULT_LANGUAGE;
}

function isValidLanguage(lang: string): lang is I18n {
    return Object.values(I18n).includes(lang as I18n);
}

export const I18nHelper = {
    DEFAULT_LANGUAGE,
    STORAGE_KEY,
    SUPPORTED_LANGUAGES,
    initialize,
};
